import { lazy, Suspense } from 'react'

import type { ICodeEditorProps } from './CodeEditorInner'

export type { ICodeEditorProps } from './CodeEditorInner'

// Lazy-load CodeMirror runtime + @codemirror/lang-html. Code editor only
// shows up when the user opens the embed-element modal in the editor —
// no need to ship it on initial portal/course load.
const CodeEditorInner = lazy(
  () => import(/* webpackChunkName: "code-mirror" */ './CodeEditorInner'),
)

const CodeEditor: React.FC<ICodeEditorProps> = (props) => (
  <Suspense fallback={null}>
    <CodeEditorInner {...props} />
  </Suspense>
)

export default CodeEditor
